export default {
  conversation_dnd_message: '{name} est en mode Ne pas déranger',
  conversation_dnd_message_with_time:
    "{name} est en mode Ne pas déranger jusqu'à {time, time, short}",
  conversation_dnd_message_tooltip_content:
    '{name} ne recevra pas de notifications',
};
